import { ethers } from 'ethers';
import { NetworkConfig } from '../config/networks';
import { getTokenSymbol } from '../contracts/contract';

/**
 * Gets the display symbol for a token address.
 * For native currency (ZeroAddress), returns the network's native currency symbol.
 * For ERC20 tokens, fetches the token symbol from the contract.
 * Falls back to 'Token' if fetching fails.
 * 
 * @param tokenAddress - The token address (ZeroAddress for native currency)
 * @param provider - The ethers provider
 * @param network - The network configuration
 * @returns The token symbol (never throws, always returns a string)
 */
export const getTokenSymbolDisplay = async (
  tokenAddress: string,
  provider: ethers.Provider,
  network: NetworkConfig
): Promise<string> => {
  // For native currency, use the network's native currency symbol
  if (tokenAddress === ethers.ZeroAddress) {
    return network.nativeCurrency.symbol;
  }
  
  // For ERC20 tokens, fetch the symbol from the contract
  try {
    return await getTokenSymbol(provider, tokenAddress);
  } catch (error) {
    console.warn(`Failed to fetch symbol for ${tokenAddress}:`, error);
    return 'Token';
  }
};

